import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { compose } from 'react-apollo';
import { Button, Form, Grid, TextArea } from 'semantic-ui-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import * as yup from 'yup';

import { FormComponents } from '../components';
import { GridNumbers } from '../utils';
import { withAuth } from '../auth';

const EmailResultsForm = ({
  intl,
  error,
  onSubmit,
  authUser,
  querySelections,
  products
}) => {
  const validationSchema = yup.object().shape({
    customerFirstName: yup.string().required(),
    customerLastName: yup.string().required(),
    customerEmail: yup
      .string()
      .required()
      .email()
  });

  const authUserForEmailForm = {
    email: authUser.email,
    lastName: authUser.lastName || '',
    givenName: authUser.givenName || '',
    phoneNumber: authUser.phoneNumber || '',
    sub: authUser.sub
  };

  const querySelectionsForEmailForm = {
    primaryUse: querySelections.PRIMARY_USE,
    maxBinHeight: querySelections.MAX_BIN_HEIGHT,
    minBph: querySelections.MIN_BPH
  };

  return (
    <Formik
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      initialValues={{
        ...authUserForEmailForm,
        ...querySelectionsForEmailForm,
        products: products || [],
        customerEmail: '',
        customerFirstName: '',
        customerLastName: '',
        message: ''
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, handleChange }) => (
        <Form onSubmit={handleSubmit} error={!!error}>
          <h2>
            <FormattedMessage
              id="title.emailresults"
              description="Email Results Form title"
              defaultMessage="Email these Suggestions"
            />
          </h2>
          <Form.Field>
            <p>
              <FormattedMessage
                id="description.emailresults"
                description="Email Results Form description"
                defaultMessage="These suggestions will be saved as a PDF and sent to your customer. You will receive a copy of this email as well."
              />
            </p>
          </Form.Field>

          <Grid>
            <Grid.Column
              mobile={GridNumbers.base}
              computer={GridNumbers.content}
            >
              <FormComponents.Field
                type="text"
                name="customerFirstName"
                label={intl.formatMessage({
                  id: 'form.customer_first_name',
                  defaultMessage: "Customer's First Name"
                })}
              />

              <FormComponents.Field
                type="text"
                name="customerLastName"
                label={intl.formatMessage({
                  id: 'form.customer_last_name',
                  defaultMessage: "Customer's Last Name"
                })}
              />

              <FormComponents.Field
                type="email"
                name="customerEmail"
                label={intl.formatMessage({
                  id: 'form.customer_email',
                  defaultMessage: "Customer's Email Address"
                })}
              />
              <Form.Field />
            </Grid.Column>
          </Grid>

          <FormComponents.Field
            name="message"
            onChange={handleChange('message')}
            component={TextArea}
            label={`${intl.formatMessage({
              id: 'form.personal_message',
              defaultMessage: 'Personal Message'
            })} (${intl.formatMessage({
              id: 'form.optional',
              defaultMessage: 'optional'
            })})`}
            style={{ minHeight: '120px' }}
          />

          <FormComponents.FormError error={error} />

          <Form.Field
            type="submit"
            control={Button}
            size="small"
            primary
            data-qa="submit-email-result-button"
            disabled={isSubmitting || !isValid}
          >
            <FormattedMessage id="cta.send" defaultMessage="Send" />
          </Form.Field>
        </Form>
      )}
    </Formik>
  );
};

EmailResultsForm.propTypes = {
  intl: intlShape.isRequired,
  error: PropTypes.string,
  onSubmit: PropTypes.func,
  toggleForm: PropTypes.func.isRequired,
  authUser: PropTypes.object,
  querySelections: PropTypes.object,
  products: PropTypes.array
};

export default compose(
  withAuth,
  injectIntl
)(EmailResultsForm);



// WEBPACK FOOTER //
// ./src/forms/EmailResultsForm.js